import React, { useContext } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { FluctuationsChart } from '@bingads-webui-react/fluctuations-chart';
import { I18nContext } from '@bingads-webui/copilot-i18n';

import { IPerformanceTimeSeries } from '../../types';

const useStyles = makeStyles({
  root: {
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    overflowY: 'hidden',
    height: '100%',
  },
  preview: {
    height: `calc(${tokens.lineHeightBase200} * 10)`,
  },
});

export type InsightsChartProps = {
  className?: string;
  performanceTimeSeries: IPerformanceTimeSeries;
  isLoading?: boolean;
  isPreview?: boolean;
  TimeZone: number;
};

export const InsightsChart: React.FC<InsightsChartProps> = React.memo((props) => {
  const {
    className,
    performanceTimeSeries,
    isLoading,
    isPreview,
    TimeZone,
  } = props;

  const classes = useStyles();
  const i18n = useContext(I18nContext);

  return (
    <div className={mergeClasses('insights-chart', classes.root, isPreview && classes.preview, className)}>
      <FluctuationsChart
        TimeZone={TimeZone}
        performanceTimeSeries={performanceTimeSeries}
        isLoading={isLoading}
        size={isPreview ? 'small' : 'large'}
        i18n={i18n}
      />
    </div>
  );
});
